import { render, staticRenderFns } from "./LoginPopupFbCanvasCommon.vue?vue&type=template&id=393394b9&scoped=true&"
import script from "./LoginPopupFbCanvasCommon.vue?vue&type=script&lang=js&"
export * from "./LoginPopupFbCanvasCommon.vue?vue&type=script&lang=js&"
import style0 from "./LoginPopupFbCanvasCommon.vue?vue&type=style&index=0&id=393394b9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "393394b9",
  null
  
)

component.options.__file = "LoginPopupFbCanvasCommon.vue"
export default component.exports